import { UndoOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Row, Table, Checkbox } from 'antd';
import { useForm } from 'antd/es/form/Form';
import TextArea from 'antd/es/input/TextArea';
import Column from 'antd/es/table/Column';
import { Space } from 'antd/lib';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { idNhomKPI } from '../../constants';
import { ChiTietKPITrangChu } from '../../models/kpi/KPICaNhan';
import { luuChiTietKPICaNhan } from '../../services/kpi';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import dayjs from 'dayjs';

const KPITrangChu = () => {
    const dispatch = useDispatch();
    const [form] = useForm();
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<Array<ChiTietKPITrangChu>>([]);

    const defaultData: Array<ChiTietKPITrangChu> = [{
        key: 0,
        id: 0,
        idKPI: 0,
        idNhomKPI: idNhomKPI.chuyenMon,
        tenCongViec: "",
        thoiGianGiao: dayjs().startOf('month').toDate(),
        thoiGianYeuCauHoanThanh: dayjs().endOf('month').toDate(),
        ghiChu: "",
        baoCao: false
    }];

    type FieldChiTietKPI = {
        "tenCongViec": string;
        "thoiGianGiao": Date;
        "thoiGianYeuCauHoanThanh": Date;
        "ghiChu": string;
        "baoCao": boolean;
    };

    const onFinish = (values: any) => {
        setConfirmModal({
            isShowModal: true,
            title: "Lưu nội dung KPI",
            content:
                <>Bạn có muốn <label>Lưu</label> nội dung vào KPI cá nhân tháng này không?</>,
            onSubmit: eventSaveChiTietKPI
        });
    };

    const eventSaveChiTietKPI = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values: {
            tenCongViec: string;
            thoiGianGiao: { $d: any; };
            thoiGianYeuCauHoanThanh: { $d: any; };
            ghiChu: string;
            baoCao: boolean;
        }) => {
            dispatch(showLoadingScreen())
            setIsLoading(true);
            try {
                var request = {
                    tenCongViec: values.tenCongViec,
                    thoiGianGiao: values.thoiGianGiao.$d,
                    thoiGianYeuCauHoanThanh: values.thoiGianYeuCauHoanThanh.$d,
                    baoCao: values.baoCao,
                    ghiChu: values.ghiChu
                };
                await luuChiTietKPICaNhan(request);
                eventResetKPI();
                toast.success("Lưu nội dung KPI cá nhân thành công");
            } catch (error: any) {
                toast.error(error);
            }
            setIsLoading(false);
            dispatch(hideLoadingScreen());
        }).catch((e: any) => {
            toast.error(e);
            dispatch(hideLoadingScreen());
        });
    }

    const eventResetKPI = () => {
        form.setFieldsValue({
            tenCongViec: "",
            thoiGianGiao: dayjs().startOf('month'),
            thoiGianYeuCauHoanThanh: dayjs().endOf('month'),
            baoCao: false,
            ghiChu: ""
        });
    }

    useEffect(() => {
        form.setFieldsValue({
            tenCongViec: "",
            thoiGianGiao: dayjs().startOf('month'),
            thoiGianYeuCauHoanThanh: dayjs().endOf('month'),
            baoCao: false,
            ghiChu: ""
        });
        setData(defaultData);
    }, []);

    return (
        <>
            <Col xs={24} xl={24}>
                <Row style={{ marginBottom: "10px" }}>
                    <Col span="12">
                        <Row><b style={{ fontSize: "20px", color: "#071C50" }}>KPI cá nhân</b></Row>
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%" }}>
                        <Form
                            layout="vertical"
                            onFinish={onFinish}
                            onSubmitCapture={(e) => e.preventDefault()}
                            form={form}
                        >
                            <Table
                                scroll={{ x: "max-content" }}
                                pagination={false}
                                size="small"
                                dataSource={(data || []).map((x: ChiTietKPITrangChu, idx: number) => { x.key = idx; return x; })}
                            >
                                <Column
                                    title="Nội dung"
                                    key="tenCongViec"
                                    dataIndex="tenCongViec"
                                    render={(value, record, index) => {
                                        return (
                                            <Form.Item<FieldChiTietKPI>
                                                name="tenCongViec"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Tên công việc bắt buộc nhập"
                                                    }
                                                ]}
                                            >
                                                <TextArea rows={2}
                                                    value={value}
                                                    placeholder="Nhập công việc"
                                                />
                                            </Form.Item>
                                        );
                                    }}
                                />
                                <Column
                                    align="center"
                                    title="Thời gian giao"
                                    key="thoiGianGiao"
                                    dataIndex="thoiGianGiao"
                                    width="150px"
                                    render={(value, record, index) => {
                                        return (
                                            <Form.Item<FieldChiTietKPI>
                                                name="thoiGianGiao"
                                            >
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    allowClear={false}
                                                    value={dayjs(value)}
                                                    picker="date"
                                                    format={["DD/MM/YYYY", "DDMMYYYY"]}
                                                    onChange={(e: any) => {
                                                        form.setFieldsValue({
                                                            thoiGianGiao: e,
                                                        });
                                                    }}
                                                />
                                            </Form.Item>
                                        );
                                    }}
                                />
                                <Column
                                    align="center"
                                    title="Thời gian yêu cầu"
                                    key="thoiGianYeuCauHoanThanh"
                                    dataIndex="thoiGianYeuCauHoanThanh"
                                    width="150px"
                                    render={(value, record, index) => {
                                        return (
                                            <div style={{ textAlign: "left" }}>
                                            <Form.Item<FieldChiTietKPI>
                                                name="thoiGianYeuCauHoanThanh"
                                            >
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    allowClear={false}
                                                    value={dayjs(value)}
                                                    picker="date"
                                                    format={["DD/MM/YYYY", "DDMMYYYY"]}
                                                    onChange={(e: any) => {
                                                        form.setFieldsValue({
                                                            thoiGianYeuCauHoanThanh: e,
                                                        });
                                                    }}
                                                />
                                                </Form.Item>
                                                <Form.Item<FieldChiTietKPI>
                                                    name="baoCao"
                                                    valuePropName="checked"
                                                    style={{ marginBottom: 0 }}
                                                >
                                                    <Checkbox title="Theo dõi công việc">Báo cáo</Checkbox>
                                                </Form.Item>
                                            </div>
                                        );
                                    }}
                                />
                                <Column
                                    title="Ghi chú"
                                    key="ghiChu"
                                    dataIndex="ghiChu"
                                    width= "200px"
                                    render={(value, record, index) => {
                                        return (
                                            <Form.Item<FieldChiTietKPI>
                                                name="ghiChu"
                                            >
                                                <TextArea rows={2}
                                                    value={value}
                                                    placeholder="Nhập ghi chú"
                                                />
                                            </Form.Item>
                                        );
                                    }}
                                />
                                <Column
                                    align="center"
                                    title=""
                                    width="100px"
                                    dataIndex=""
                                    key=""
                                    render={(value, record, index) => {
                                        return (
                                            <Form.Item>
                                                <Space direction="vertical">
                                                    <Button
                                                        loading={isLoading}
                                                        className="btn-primary"
                                                        type="primary"
                                                        icon={<SaveOutlined rev="" />}
                                                        htmlType="submit"
                                                        size={"small"}
                                                    > Lưu
                                                    </Button>
                                                    <Button
                                                        loading={isLoading}
                                                        className="hrm-btn-warning"
                                                        icon={<UndoOutlined rev="" />}
                                                        onClick={eventResetKPI}
                                                        size={"small"}
                                                    > Reset
                                                    </Button>
                                                </Space>
                                            </Form.Item>
                                        )
                                    }}
                                />
                            </Table>
                        </Form>
                        <ModalTextForm
                            show={confirmModal.isShowModal}
                            title={confirmModal.title}
                            handleClose={() => setConfirmModal({ isShowModal: false })}
                            handleSave={() => {
                                confirmModal.onSubmit();
                                setConfirmModal({ isShowModal: false });
                            }}
                        >
                            {confirmModal.content}
                        </ModalTextForm>
                    </div>
                </Row>
            </Col>
        </>
    );
};

export default KPITrangChu;
